import auth from "@/pages/auth/i18n/de";
import dashboard from "@/pages/dashboard/i18n/de";
import time from "@/pages/time/i18n/de";
import leave from "@/pages/leave/i18n/de";
import hr from "@/pages/hr/i18n/de";
import feedback from "@/pages/pending-feedbacks/i18n/de";

export default {
  ...auth,
  ...dashboard,
  ...time,
  ...leave,
  ...hr,
  ...feedback,
  menu: {
    dashboard: "Startseite",
    time: "Zeit",
    hr: "Human Resources",
    leave: "Urlaub/Abwesenheiten",
    clock_in_out: "Clock In / Out"
  },
  message: {
    saved_successfully: "Gespeichert",
    updated_successfully: "erfolgreich aktualisiert",
    deleted_successfully: "erfolgreich gelöscht",
    download_email_report: "Click the download button to download the file",
    registration_successful: "Registrierung Erfolgreich",
    registration_failed: "Registrierung Fehlgeschlagen",
    pass_reset_time_early:
      "Sie müssen mindestens 3 Minuten warten, um ein neues Token zum Zurücksetzen des Passworts anzufordern!",
    entity_not_found: "Konto nicht gefunden",
    pass_reset_leng_err: "Ihr Passwort muss mindestens 6 Zeichen und maximal 16 Zeichen lang sein."
  },
  global: {
    comment: "Beschreibung",
    description: "Beschreibung",
    day: "Tag",
    note: "Notiz",
    employee: "Arbeitnehmer",
    address: "Adresse",
    explanation: "Grund/Beschreibung",
    hour: "Stunde",
    month: "Monat",
    phone: "Telefon",
    status: "Status",
    file: "Datei",
    greeting: "Guten Tag, {0}",
    search_for_employee: "Mitarbeiter suchen...",
    others: "Sonstiges",
    importance_enum: {
      LOW: "Gering",
      MEDIUM: "Mittel",
      HIGH: "Hoch"
    },
    importance: "Priorität",
    date: "Datum",
    loading_message: "Wird geladen …",
    birth_date: "Geburtsdatum",
    min_character_message: "Es müssen mindestens {0} Zeichen angegeben werden",
    no_employee_message: "Unter den angegeben Kriterien wurde kein Mitarbeiter gefunden.",
    employees: "Mitarbeiter",
    beginDate: "Startdatum",
    endDate: "Enddatum",
    beginTime: "Startzeit",
    endTime: "Endzeit",
    year: "Jahr",
    message: "Message",
    country: "Country",
    active_employees: "Active Employees",
    passive_employees: "Passive Employees",
    maxEmployeeCount: "Max Employee Count",
    years_old: "years old",
    print: "Print",
    expense_management: "Expense Management",
    uploaded_files: "Uploaded Files",
    loading: "Loading...",
    employee_selected: "Select employee...|1 employee selected|{count} employees selected",
    shift_selected: "Select shift...|1 shift selected|{count} shifts selected",
    shifts_type: "{0} Shifts",
    total_hours: "Gesamtstunden"
  },
  assessment: {
    very_poor: "ungenügend",
    poor: "nicht zufriedenstellend",
    normal: "Normal",
    good: "gut",
    very_good: "sehr gut",
    na: "keine Bewertung"
  },
  buttons: {
    home: "Startseite",
    ok: "OK",
    delete: "Löschen",
    back: "Zurück",
    save: "Speichern",
    update: "Aktualisieren",
    edit: "Bearbeiten",
    cancel: "Abbrechen",
    close: "Schließen",
    dont_save: "Abbrechen und Schließen",
    dont_save_continue: "Nicht Speichern Weiter",
    save_changes: "Speichern und Weiter",
    evaluation_finish: "Bewertung abschließen",
    assign: "beauftragen",
    add: "{0} hinzufügen",
    add_and_new: "Neu hinzufügen",
    refresh: "aktualisieren",
    filter: "Filter",
    export: "exportieren",
    create: "{0} erstellen ",
    create_and_new: "Neu erstellen",
    download: "downloaden",
    yes: "Ja",
    no: "Nein",
    clear: "Löschen",
    filter_results: "Ergebnisse filtern",
    delete_document: "Dokument löschen",
    scan: "Scannen",
    send_message: "Nachricht senden",
    send: "senden",
    apply: "ausführen",
    info: "Information",
    prev: "Zurück {0}",
    next: "Weiter {0}",
    list_table: "Tabellenmodus",
    list_card: "Kartenmodus",
    continue: "Weiter",
    show_all: "alle anzeigen",
    cancel_leave: "abbrechen und verlassen",
    select_all: "alle auswählen",
    upload: "hochladen",
    file_upload: "Datei hochladen",
    file_download: "Datei herunterladen",
    import: "importieren",
    upload_template: "Template hochladen",
    download_template: "Template herunterladen",
    trigger: "Trigger",
    action: "Aktion",
    send_registration_credentials: "Zugangsdaten senden",
    on: "An",
    off: "Aus",
    uploads: {
      employee: "Personal importieren",
      leave: "Abwesenheiten importieren"
    },
    multiple_delete_shift: "Bulk Shift Delete",
    multiple_upload_shift: "Bulk Shift Upload",
    multiple_actions: "Bulk Actions",
    send_email_and_sms_notification: "E-Mail und SMS-Benachrichtigungen senden",
    add_expense: "Kosten hinzufügen",
    add_imprest: "Zahlstelle hinzufügen",
    add_overtime: "Überstunden hinzufügen",
    add_leave_request: "Urlaubsantrag hinzufügen",
    evaluatee: "Gutachter:In",
    add_skill: "Skill hinzufügen",
    sign: "Zeichen",
    skip: "überspringen",
    back_to_home: "Back to Home",
    please_select: "Please select..."
  },
  response: {
    success: {
      ok: "Die Bedienun gist erfolgreich",
      update: "erfolgreich aktualisiert",
      delete: "erfolgreich gelöscht",
      send_sms_password_code: "Der Code zum Zurücksetzen des Passwortes wurde in einer SMS-Nachricht verschickt "
    },
    error: {
      user_not_found: "Benutzername oder Passwort nicht korrekt",
      network_error: "Netzwerkfehler"
    }
  },
  request_status: {
    PENDING: "Bestätigung ausstehend",
    pending: "Bestätigung ausstehend",
    approved: "bestätigt",
    APPROVED: "bestätigt",
    denied: "abgelehnt",
    DENIED: "abgelehnt",
    cancelled: "abgebrochen",
    CANCELLED: "abgebrochen",
    NEED_EXTRA_DETAIL: "Es werden zusätzliche Details benötigt",
    need_extra_detail: "Es warden zusätzliche Details benötigt",
    undefined: "undefiniert",
    STOPPED: "Stopped",
    stopped: "Stopped",
    not_come: "Not Come",
    NOT_COME: "Not Come"
  },
  shift_types: {
    FIX: "festgelegt",
    FLEXIBLE: "flexibel",
    OFF_DAY: "arbeitsfreier Tag",
    OFFDAY: "arbeitsfreier Tag",
    HOLIDAY: "Ferien",
    WORKDAY: "Arbeitstag",
    BREAK: "Pause",
    OVERTIME: "Überstunden",
    OVERTIME_SHIFT: "Überstunden",
    ON_LEAVE: "Im Urlaub"
  },
  shift: {
    overtime: "Überstunden",
    missing_time: "fehlende Stunden",
    shift_parameters: "Shift Parameters",
    break: "Pause",
    sub_events: "Sub Events",
    included_calculation: "In den Berechnungen enthalten",
    not_included_calculation: "Nicht in den Berechnungen enthalten",
    included_overtime_calculation: "Überstunden sind in den Berechnungen nicht enthalten",
    not_included_overtime_calculation: "Überstunden sind in den Berechnungen enthalten",
    not_included_missing_time_calculation: "Fehlende Arbeitsstunden sind in den Berechnungen nicht enthalten",
    included_missing_time_calculation: "Fehlende Arbeitsstunden sind in den Berechnungen enthalten",
    work_day: "Arbeitstag",
    overtime_day: "Tag mit Überstunden",
    full_time: "Vollzeit",
    absent: "abwesend",
    unpaid_leave: "unbezahlter Urlaub",
    paid_leave: "bezahlter Urlaub",
    public_holiday: "gesetzlicher Ferientag",
    on_leave: "im Urlaub",
    off_day: "arbeitsfreier Tag",
    break_day: "Pause",
    incalculable: "Schichtzeit lässt sich nicht erschließen"
  },
  sensors: {
    NFC: "NFC",
    FACE: "Gesicht",
    RFID: "RFID",
    FINGER: "Fingerabdruck",
    BLUETOOTH: "Bluetooth",
    GATEWARE: "Gateware",
    BEACON: "Beacon",
    GPS: "Standort",
    WIFI: "Wi-Fi",
    ID: "ID",
    QR: "QR",
    QR_CODE: "QR Code",
    PASSWORD: "Passwort",
    PIN: "PIN",
    CARD: "Karte",
    FIXED: "fixiert",
    EXTERNAL: "extern",
    JAN: "JAN",
    WEB: "Web"
  },
  identity_type: {
    FACE: "Gesicht",
    PASSWORD: "Passwort",
    PIN: "PIN",
    FINGER: "Fingerabdruck",
    QR_CODE: "QR Code",
    CARD: "Karte",
    EXTERNAL: "extern"
  },
  event_types: {
    BREAK_IN: "Pause Beginn",
    BREAK_OUT: "Pause Ende",
    LUNCH_IN: "Mittagspause Beginn",
    LUNCH_OUT: "Mittagspause Ende",
    DUTY_IN: "Dienstbeginn",
    DUTY_OUT: "Dienstende",
    CLOCK_IN: "Clock In",
    CLOCK_OUT: "Clock Out",
    HOME_CLOCK_IN: "Startseite Clock In",
    HOME_CLOCK_OUT: "Startseite Clock  Out",
    TRAINING_IN: "Ausbildung in",
    TRAINING_OUT: "Ausbilden",
    UNKNOWN: "In oder Out",
    undefined: "unbekannt"
  },
  currency: {
    amount: "Menge",
    code: "Code",
    requested_amount: "angefragte Menge",
    approved_amount: "bestätigte menge",
    codes: {
      TRY: "TRY",
      USD: "USD",
      EUR: "EUR"
    }
  },
  titles: {
    expense: {
      create: "Ausgaben hinzufügen",
      detail: "Ausgabendetails"
    },
    imprest: {
      create: "Zahlstellen hinzufügen",
      detail: "Zahlstellendetails"
    }
  },
  language: {
    tr: "Türkisch",
    en: "Englisch",
    de: "Deutsch",
    TURKISH: "Türkisch",
    ENGLISH: "Englisch",
    GERMAN: "Deutsch"
  },
  status: {
    active: "Aktiv",
    passive: "Passiv",
    enable: "Aktiviert",
    disable: "Deaktiviert"
  },
  gender: {
    male: "männlich",
    female: "weiblich",
    other: "divers",
    others: "andere Angaben",
    MALE: "männlich",
    FEMALE: "weiblich",
    OTHER: "divers"
  },
  marital_status: {
    married: "verheiratet",
    single: "ledig",
    divorced: "geschieden"
  },
  education: {
    student: "Student:In",
    primary_school: "Grundschule",
    secondary_school: "weiterführende Schule",
    high_school: "Gymnasiale Oberstufe",
    collage: "Fachhochschule",
    university: "Universität",
    master: "Master",
    phd: "PhD",
    graduate: "Graduate",
    course: "Course",
    seminar: "Seminar",
    workshop: "Workshop",
    other: "Other"
  },
  education_languages: {
    turkish: "Türkisch",
    english: "Englisch",
    german: "Deutsch",
    french: "Französisch",
    dutch: "Niederländisch",
    spanish: "Spanisch",
    italian: "Italienisch",
    arabic: "Arabisch",
    russian: "Russisch",
    persian: "Persisch",
    chinese: "Chinesisch",
    japanese: "Japanisch",
    hindi: "Hindi",
    latin: "Latein",
    portuguese: "Portugiesisch",
    korean: "Koreanisch"
  },
  military_service: {
    done: "gedient",
    undone: "nicht gedient",
    exempt: "freigestellt",
    suspended: "suspendiert"
  },
  academic_title: {
    lecturer: "Dozent:In",
    research_assistant: "Research Assistant",
    assistant_professor: "Assistant Professor",
    associate_professor: "Associate Professor",
    professor: "Professor"
  },
  employment_type: {
    full_time: "Vollzeit",
    part_time: "Halbtags",
    casual: "nicht vertragsgebunden",
    contracted: "vertragsgebunden",
    freelance: "selbstständig",
    intern: "Intern",
    mobile: "mobil",
    retired: "Retired",
    trial: "Trial",
    seasonal: "Seasonal",
    disabled: "Disabled"
  },
  collar_type: {
    white: "weiß",
    blue: "blau",
    gray: "grau"
  },
  quite_job_reasons: {
    resignation: "Kündigung",
    cancellation_of_labor_contract: "Aufhebungsvertrag",
    military_service: "Militärdienst",
    other: "Andere Gründe"
  },
  blood_type: {
    o_rh_negative: "0-",
    o_rh_positive: "0+",
    a_rh_negative: "A-",
    a_rh_positive: "A+",
    b_rh_negative: "B-",
    b_rh_positive: "B+",
    ab_rh_negative: "AB-",
    ab_rh_positive: "AB+"
  },
  time_duration: {
    hour: "Stunde",
    minute: "Minute",
    second: "Sekunde"
  },
  date: {
    year: "Jahr",
    month: "Monat",
    day: "Tag",
    time: "Zeit",
    week: "Woche",
    minute: "Minute"
  },
  validations: {
    messages: {
      phone: "The {_field_} field must be a valid phone number",
      password_match: "Passwords don't match",
      password_math: "Passwords don't match",
      integer: "The {_field_} field must be an integer",
      date: "Enter a valid date format (yyyy-mm-dd)"
    }
  },
  nationalities: {
    Afghan: "Afghan",
    Albanian: "Albanian",
    Algerian: "Algerian",
    American: "American",
    Andorran: "Andorran",
    Angolan: "Angolan",
    Antiguans: "Antiguans",
    Argentinean: "Argentinean",
    Armenian: "Armenian",
    Australian: "Australian",
    Austrian: "Austrian",
    Azerbaijani: "Azerbaijani",
    Bahamian: "Bahamian",
    Bahraini: "Bahraini",
    Bangladeshi: "Bangladeshi",
    Barbadian: "Barbadian",
    Barbudans: "Barbudans",
    Botswana: "Botswana",
    Belarusian: "Belarusian",
    Belgian: "Belgian",
    Belizean: "Belizean",
    Beninese: "Beninese",
    Bhutanese: "Bhutanese",
    Bolivian: "Bolivian",
    Bosnian: "Bosnian",
    Brazilian: "Brazilian",
    British: "British",
    Bruneian: "Bruneian",
    Bulgarian: "Bulgarian",
    Burkinabe: "Burkinabe",
    Burmese: "Burmese",
    Burundian: "Burundian",
    Cambodian: "Cambodian",
    Cameroonian: "Cameroonian",
    Canadian: "Canadian",
    "Cape Verdean": "Cape Verdean",
    "Central African": "Central African",
    Chadian: "Chadian",
    Chilean: "Chilean",
    Chinese: "Chinese",
    Colombian: "Colombian",
    Comoran: "Comoran",
    Congolese: "Congolese",
    "Costa Rican": "Costa Rican",
    Croatian: "Croatian",
    Cuban: "Cuban",
    Cypriot: "Cypriot",
    Czech: "Czech",
    Danish: "Danish",
    Djibouti: "Djibouti",
    Dominican: "Dominican",
    Dutch: "Dutch",
    "East Timorese": "East Timorese",
    Ecuadorean: "Ecuadorean",
    Egyptian: "Egyptian",
    Emirian: "Emirian",
    "Equatorial Guinean": "Equatorial Guinean",
    Eritrean: "Eritrean",
    Estonian: "Estonian",
    Ethiopian: "Ethiopian",
    Fijian: "Fijian",
    Filipino: "Filipino",
    Finnish: "Finnish",
    French: "French",
    Gabonese: "Gabonese",
    Gambian: "Gambian",
    Georgian: "Georgian",
    German: "German",
    Ghanaian: "Ghanaian",
    Greek: "Greek",
    Grenadian: "Grenadian",
    Guatemalan: "Guatemalan",
    "Guinea-Bissauan": "Guinea-Bissauan",
    Guinean: "Guinean",
    Guyanese: "Guyanese",
    Haitian: "Haitian",
    Herzegovinian: "Herzegovinian",
    Honduran: "Honduran",
    Hungarian: "Hungarian",
    "I-Kiribati": "I-Kiribati",
    Icelander: "Icelander",
    Indian: "Indian",
    Indonesian: "Indonesian",
    Iranian: "Iranian",
    Iraqi: "Iraqi",
    Irish: "Irish",
    Israeli: "Israeli",
    Italian: "Italian",
    Ivorian: "Ivorian",
    Jamaican: "Jamaican",
    Japanese: "Japanese",
    Jordanian: "Jordanian",
    Kazakhstani: "Kazakhstani",
    Kenyan: "Kenyan",
    "Kittian and Nevisian": "Kittian and Nevisian",
    Kuwaiti: "Kuwaiti",
    Kyrgyz: "Kyrgyz",
    Laotian: "Laotian",
    Latvian: "Latvian",
    Lebanese: "Lebanese",
    Liberian: "Liberian",
    Libyan: "Libyan",
    Liechtensteiner: "Liechtensteiner",
    Lithuanian: "Lithuanian",
    Luxembourger: "Luxembourger",
    Macedonian: "Macedonian",
    Malagasy: "Malagasy",
    Malawian: "Malawian",
    Malaysian: "Malaysian",
    Maldivan: "Maldivan",
    Malian: "Malian",
    Maltese: "Maltese",
    Marshallese: "Marshallese",
    Mauritanian: "Mauritanian",
    Mauritian: "Mauritian",
    Mexican: "Mexican",
    Micronesian: "Micronesian",
    Moldovan: "Moldovan",
    Monacan: "Monacan",
    Mongolian: "Mongolian",
    Moroccan: "Moroccan",
    Mosotho: "Mosotho",
    Motswana: "Motswana",
    Mozambican: "Mozambican",
    Namibian: "Namibian",
    Nauruan: "Nauruan",
    Nepalese: "Nepalese",
    "New Zealander": "New Zealander",
    Nicaraguan: "Nicaraguan",
    Nigerian: "Nigerian",
    Nigerien: "Nigerien",
    "North Korean": "North Korean",
    "Northern Irish": "Northern Irish",
    Norwegian: "Norwegian",
    Omani: "Omani",
    Pakistani: "Pakistani",
    Palauan: "Palauan",
    Panamanian: "Panamanian",
    "Papua New Guinean": "Papua New Guinean",
    Paraguayan: "Paraguayan",
    Peruvian: "Peruvian",
    Polish: "Polish",
    Portuguese: "Portuguese",
    Qatari: "Qatari",
    Romanian: "Romanian",
    Russian: "Russian",
    Rwandan: "Rwandan",
    "Saint Lucian": "Saint Lucian",
    Salvadoran: "Salvadoran",
    Samoan: "Samoan",
    "San Marinese": "San Marinese",
    "Sao Tomean": "Sao Tomean",
    Saudi: "Saudi",
    Scottish: "Scottish",
    Senegalese: "Senegalese",
    Serbian: "Serbian",
    Seychellois: "Seychellois",
    "Sierra Leonean": "Sierra Leonean",
    Singaporean: "Singaporean",
    Slovakian: "Slovakian",
    Slovenian: "Slovenian",
    "Solomon Islander": "Solomon Islander",
    Somali: "Somali",
    "South African": "South African",
    "South Korean": "South Korean",
    Spanish: "Spanish",
    "Sri Lankan": "Sri Lankan",
    Sudanese: "Sudanese",
    Surinamer: "Surinamer",
    Swazi: "Swazi",
    Swedish: "Swedish",
    Swiss: "Swiss",
    Syrian: "Syrian",
    Taiwanese: "Taiwanese",
    Tajik: "Tajik",
    Tanzanian: "Tanzanian",
    Thai: "Thai",
    Togolese: "Togolese",
    Tongan: "Tongan",
    "Trinidadian or Tobagonian": "Trinidadian or Tobagonian",
    Tunisian: "Tunisian",
    Turkish: "Turkish",
    Tuvaluan: "Tuvaluan",
    Ugandan: "Ugandan",
    Ukrainian: "Ukrainian",
    Uruguayan: "Uruguayan",
    Uzbekistani: "Uzbekistani",
    Venezuelan: "Venezuelan",
    Vietnamese: "Vietnamese",
    Welsh: "Welsh",
    Yemenite: "Yemenite",
    Zambian: "Zambian",
    Zimbabwean: "Zimbabwean"
  },
  disability_level: {
    first_level: "First Level",
    second_level: "Second Level",
    third_level: "Third Level"
  },
  social_security_type: {
    SS_4A: "4A",
    SS_4B: "4B",
    SS_4C: "4C"
  },
  days: {
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday"
  },
  api_error: {
    "401": "Your e-mail or password is incorrect",
    "403": "Your role is not authorized to login",
    "700": "Bad Request",
    "701": "Missing Request Parameter",
    "702": "Unsupported Media Type",
    "703": "Invalid Method Argument",
    "704": "Constraint Violation",
    "705": "Http Message Not Readable",
    "706": "Http Message Not Writable",
    "707": "Field Integrity Violation",
    "708": "Method Argument Type Mismatch",
    "711": "Entity Not Found",
    "712": "Property Not Found",
    "713": "File Size Too Big",
    "714": "Requested Media Not Found",
    "715": "Bad Credentials",
    "716": "Invalid Entity Operation",
    "717": "Invalid Excel Format",
    "718": "You must wait at least 3 minutes to reset a new password",
    "719": "Password reset code has expired",
    "720": "Suprema SDK Error",
    "750": "No Refresh Token",
    "751": "Data Conflict Exception",
    "752": "Illegal Registration Exception",
    "753": "Data Integrity Violation Exception",
    "754": "Email Cannot Be Send",
    "755": "Quota Exceeded Exception",
    "756": "Time Off Request Exists",
    "757": "You must wait at least 3 minutes before you can request a new code",
    "758": "Sms code expired",
    "759": "Failed to verify sms code",
    "760": "Competency items not entered",
    "762": "You are not in the active evaluation period"
  }
};
